import { DEFAULT_CONFIG, DEFAULT_TRANSLATIONS } from '../constants';
import type { Translations, AppConfiguration } from '../types';

export const getConfiguration = (element: HTMLElement): AppConfiguration => {
  if ('config' in element.dataset) {
    const { config } = element.dataset;
    const parsedConfiguration = (config ? JSON.parse(config) : {}) as Partial<AppConfiguration>; // Some things may not be set

    return {
      ...DEFAULT_CONFIG,
      ...parsedConfiguration,
    };
  }

  const translations = {
    ...DEFAULT_TRANSLATIONS,
    ...(JSON.parse(element.dataset.translations ?? '{}') as Partial<Translations>),
  };

  const { staticApiUrl = DEFAULT_CONFIG.staticApiUrl, tenant = DEFAULT_CONFIG.tenant } =
    element.dataset;

  return { staticApiUrl, tenant, translations };
};
